
import { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export const usePageLoader = () => {
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const isFirstLoadRef = useRef(true);

  useEffect(() => {
    // On first mount, never block first paint
    if (isFirstLoadRef.current) {
      isFirstLoadRef.current = false;
      setIsLoading(false);
      return;
    }

    // Start loading on route changes (tiny delay for smoother UX)
    setIsLoading(true);

    const isMobile = window.innerWidth < 768;
    const loadingTime = isMobile ? 25 : 75;

    const loadingTimer = setTimeout(() => {
      setIsLoading(false);
    }, loadingTime);

    return () => {
      clearTimeout(loadingTimer);
    };
  }, [location.pathname]);

  return { isLoading };
};
